<loading-animation size="large" *ngIf="!isReady"></loading-animation>

<div class="bulk-operation-wrapper" [formGroup]="deviceBulkOperationFormGroup" *ngIf="isReady">
    <popup-header text="Change Template Versions" (clickAction)="cancel()"></popup-header>

    <div mat-dialog-content fxLayout="column" class="bulk-operation-description">
        <mat-form-field fxFlex.sm="100" fxFlex.xs="100" fxFlex.gt-sm="50">
            <mat-label>Template Version</mat-label>
            <mat-select [formControl]="versionFormControl" (selectionChange)="versionChanged($event)">
                <mat-option *ngFor="let item of hardwareVersions" [value]="item.value">
                    {{ item.text }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field fxFlex.sm="100" fxFlex.xs="100" fxFlex.gt-sm="50"> 
            <mat-label>Configuration</mat-label>
            <mat-select [formControl]="configurationFormControl" (selectionChange)="configurationChanged($event)">
                <mat-option *ngFor="let configuration of configurations" [value]="configuration.id">
                    {{ configuration | deviceConfiguration }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <popup-button-container>
        <cas-button (clickAction)="cancel()" btnText="Cancel"></cas-button>
        <cas-button color="accent" (clickAction)="confirm()" btnText="Confirm"></cas-button>
    </popup-button-container>
</div>
